var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.358,
    height: 33.358,
    viewBox: "0 0 33.358 33.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69894",
    "data-name": "Raggruppa 69894",
    transform: "translate(-748.642 -2527.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35807",
    "data-name": "Tracciato 35807",
    d: "M2372.21,1254.88h-20.528a6.422,6.422,0,0,0-6.415,6.415v20.528a6.422,6.422,0,0,0,6.415,6.415h20.528a6.423,6.423,0,0,0,6.415-6.415v-20.528A6.423,6.423,0,0,0,2372.21,1254.88Zm3.849,26.943a3.853,3.853,0,0,1-3.849,3.849h-20.528a3.852,3.852,0,0,1-3.849-3.849v-20.528a3.853,3.853,0,0,1,3.849-3.849h20.528a3.854,3.854,0,0,1,3.849,3.849Z",
    transform: "translate(-1596.625 1272.262)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35808",
    "data-name": "Tracciato 35808",
    d: "M2376.276,1267.606v-1.924h-9.3v-9.3h-1.925v9.3h-7.057v-9.3h-1.924v9.3h-9.3v1.924h9.3v7.056h-9.3v1.924h9.3v9.3h1.924v-9.3h7.057v9.3h1.925v-9.3h9.3v-1.924h-9.3v-7.056Zm-11.226,7.056h-7.057v-7.056h7.057Z",
    transform: "translate(-1596.158 1272.687)",
    fill: "#111"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedBlack);
export default __webpack_public_path__ + "static/media/feed-black.c7d85d4b90fdbfa1adbaffe5fb1e8436.svg";
export { ForwardRef as ReactComponent };